import { useQuery } from "@tanstack/react-query";
import AppContext from "PFApp/app_context";
import { useSession } from "PFApp/use_session";
import { QueryOptions } from "PFTypes/request_options";
import { useContext } from "react";

import { fetchSkillsDeltaData } from "../../../services/insights/skills_delta_api";
import { queryKeys } from "./query_keys";

export type SimpleData = {
  label: string;
  value: string;
};

export type InactiveData = {
  category_1: string;
  profile_id: number;
  skills: string;
};

export type NewData = {
  category_1: string;
  counts: {
    profile_id: number;
    type: string;
  }[];
  skills: string;
};

export type SkillsDeltaData = {
  dropdown: SimpleData[];
  inactive: InactiveData[];
  new: NewData[];
};

type UseSkillsDeltaQuery = {
  params: Record<string, any>;
};

export const useSkillsDeltaQuery = (
  { params }: UseSkillsDeltaQuery,
  options?: QueryOptions<SkillsDeltaData>
) => {
  const session = useSession();
  const {
    store: { currentAccount }
  } = useContext(AppContext);
  return useQuery<SkillsDeltaData>(
    queryKeys.skillsDelta(params),
    async () => await fetchSkillsDeltaData(session.getAccessToken(), currentAccount.full_domain, params),
    options
  );
};
